var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrekr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 211.603,
    height: 86,
    viewBox: "0 0 211.603 86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_679",
    x: 0,
    y: 0,
    width: 86,
    height: 86,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#52bcef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0257da"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2021",
    "data-name": "Group 2021",
    transform: "translate(-346 -140)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2013",
    "data-name": "Group 2013",
    transform: "translate(355 146)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Ellipse_679)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_679-2",
    "data-name": "Ellipse 679",
    cx: 34,
    cy: 34,
    r: 34,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2009",
    "data-name": "Group 2009",
    transform: "translate(21.333 13.333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10499",
    "data-name": "Path 10499",
    d: "M0,0,.625,3.289v7.957H0Z",
    transform: "translate(5.623)",
    fill: "#0556b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_9",
    "data-name": "Union 9",
    d: "M.625,13.444l.472-.785V5.272l-.6.356L0,4.8,7.981,0,7.972,1.169,1.721,4.9v8.06l6.249,3.692-.008,1.2Z",
    transform: "translate(4.527 12.323)",
    fill: "#0556b4",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10511",
    "data-name": "Path 10511",
    d: "M.071,9.208,1.013,6.58,1.044,0H0Z",
    transform: "matrix(0.515, -0.857, 0.857, 0.515, 17.807, 33.264)",
    fill: "#075ab8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_8",
    "data-name": "Union 8",
    d: "M0,16.624l6.256-3.637V4.875L.008,1.172V0L8.033,4.8l-.5.833-.651-.385v7.375l.027-.016.5.832-7.4,4.383Z",
    transform: "translate(13.737 12.32)",
    fill: "#095bb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_7",
    "data-name": "Union 7",
    d: "M0,30.709V23.743l6.872-4.111V10.7L0,6.511V0L12.5,7.492h0v15h-.1L4.573,27.18l7.441,4.513L9.191,36.237Z",
    transform: "translate(13.745 6.248)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_6",
    "data-name": "Union 6",
    d: "M.023,28.74H0V0H5.623V10.281L12.5,6.248v6.429L5.623,16.785v9.123L12.5,29.991v6.2Z",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "trekr.com.au",
    d: "M14.917,4a15.927,15.927,0,0,0,4.625-.843V8.622A16.491,16.491,0,0,1,12.8,9.852q-4.413,0-6.413-2.228A9.7,9.7,0,0,1,4.366.94V-12.044H.849v-3.108L4.9-17.61,7.016-23.3h4.7v5.733h7.54v5.516h-7.54V.937A2.868,2.868,0,0,0,12.6,3.249,3.467,3.467,0,0,0,14.917,4Zm25.1-22.065a11.848,11.848,0,0,1,2.481.217l-.555,6.889a8.416,8.416,0,0,0-2.168-.241A7.791,7.791,0,0,0,34.3-9.395a6.533,6.533,0,0,0-1.963,5.059V9.37H24.986V-17.563H30.55l1.084,4.533H32a10.124,10.124,0,0,1,3.384-3.649A8.345,8.345,0,0,1,40.017-18.067ZM57.553-12.84a4.667,4.667,0,0,0-3.661,1.481,6.856,6.856,0,0,0-1.517,4.2H62.684a6.124,6.124,0,0,0-1.421-4.2,4.812,4.812,0,0,0-3.709-1.48ZM58.589,9.852A13.9,13.9,0,0,1,48.424,6.262Q44.762,2.673,44.762-3.9q0-6.769,3.384-10.467a12.051,12.051,0,0,1,9.359-3.7,11.867,11.867,0,0,1,8.889,3.252,12.3,12.3,0,0,1,3.18,8.985v3.565H52.206a7.067,7.067,0,0,0,1.855,4.889,6.527,6.527,0,0,0,4.865,1.759,20.2,20.2,0,0,0,4.6-.505,23.021,23.021,0,0,0,4.533-1.613V7.95a17.252,17.252,0,0,1-4.124,1.432,25.971,25.971,0,0,1-5.348.469ZM82.606-5.275l3.2-4.095,7.543-8.193h8.287L90.941-5.88,102.286,9.37h-8.48L86.05-1.542,82.894.992V9.37H75.548V-28.111h7.347v16.717l-.385,6.119Zm38.565-12.791a11.848,11.848,0,0,1,2.481.217l-.555,6.889a8.416,8.416,0,0,0-2.168-.241,7.791,7.791,0,0,0-5.48,1.807,6.533,6.533,0,0,0-1.963,5.059V9.37h-7.347V-17.563h5.564l1.084,4.533h.361a10.124,10.124,0,0,1,3.384-3.649,8.345,8.345,0,0,1,4.637-1.388Z",
    transform: "translate(433.95 189.963)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrekr);
export default __webpack_public_path__ + "static/media/trekr.a8b3b05dc7c0793d79d7fbd39b9a2254.svg";
export { ForwardRef as ReactComponent };